import React from 'react';
import { inject, observer } from 'mobx-react';
import UserInfo from "@/components/userInfo";
import MessageList from "@/components/messageList";
import { Tooltip } from 'antd';
import CommonStore from '@/stores/commonStore';
import IconFont from '@/common/utils/iconfont'
import './index.less'

interface BottomSettingsProps {
  CommonStore?: typeof CommonStore;
  collapsed: boolean;
}

@inject('CommonStore')
@observer
class BottomSettings extends React.Component<BottomSettingsProps, any> {
    constructor(props: BottomSettingsProps) {
        super(props);
        this.state = {
            rtt: 0,
            netLevel: 'p0',
        };
    }

    componentDidMount() {
        // 获取网络条件
        this.getNetStatus()
    }
    // 网速部分
    getNetStatus = () => {
        if (navigator.connection) {
            const connection: any = navigator.connection
            let rtt = connection.rtt
            let netLevel = this.getNetLevel(rtt)
            connection.onchange = () => {
                rtt = connection.rtt
                netLevel = (this.getNetLevel(rtt))
                this.setState({
                    rtt,
                    netLevel
                })
            }
            this.setState({
                rtt,
                netLevel
            })
        }
    }

    getNetLevel = (rtt: number) => {
        // rtt为delay延时 值越大网速越慢
        if (!rtt) return '0' //无网络
        else if (rtt >= 350) return '1' //slow
        else if (rtt >= 201 && rtt < 350) return '2'
        else if (rtt <= 200) return '3' // fast
    }

    render() {
        return (
            <div className={`bottom-settings ${this.props.collapsed ? 'collapsed' : 'open'}`}>
                {/* wifi信号强度 */}
                <div className='wifi-level'>
                    <Tooltip overlayClassName={`${this.props.collapsed ? 'net-speed-collapsed' : 'net-speed-open'}`} defaultVisible={!this.props.collapsed} className='net-status' placement="right"
                      title={<div className='net-tooltip'> {this.state.rtt} ms</div>}>
                        <IconFont type={`icon-wifi-${this.state.netLevel}`} />
                    </Tooltip>
                </div>
                {/* 消息系统 */}
                <MessageList collapsed={this.props.collapsed} />
                {/* 通用设置 */}
                {this.props.CommonStore!.isReady && <UserInfo collapsed={this.props.collapsed} />}
            </div>
        )
      }
}

export default BottomSettings
